import React from 'react';

const wrapperStyle = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	textAlign: 'center',
	padding: '80px 20px',
	fontFamily: 'Arial, Helvetica, sans-serif',
	color: '#333333',
};

const headingStyle = {
	fontSize: '22px',
	fontWeight: 'bold',
	marginBottom: '12px',
};

const messageStyle = {
	fontSize: '16px',
	lineHeight: 1.5,
	maxWidth: '480px',
	marginBottom: '24px',
};

const buttonStyle = {
	padding: '10px 24px',
	fontSize: '16px',
	color: '#ffffff',
	backgroundColor: '#5A3FF5',
	border: 'none',
	borderRadius: '4px',
	cursor: 'pointer',
};

/**
 * Catches render/lifecycle errors in its subtree and shows a plain-English
 * fallback instead of a white screen.
 *
 * The fallback deliberately avoids react-intl, styled-components and any
 * other app infrastructure — if the boundary has tripped, those may be the
 * very thing that is broken.
 */
class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
		this.handleReload = this.handleReload.bind(this);
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		// Surface the error for monitoring tools / console debugging.
		// eslint-disable-next-line no-console
		console.error('ErrorBoundary caught an error:', error, errorInfo);
	}

	handleReload() {
		window.location.reload();
	}

	render() {
		if (this.state.hasError) {
			return (
				<div style={wrapperStyle}>
					<div style={headingStyle}>Something went wrong</div>
					<div style={messageStyle}>
						Please reload the page to try again. If the problem continues, contact the
						organisation that sent you this link.
					</div>
					<button type="button" style={buttonStyle} onClick={this.handleReload}>
						Reload
					</button>
				</div>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
